import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-primary py-8 md:py-12 px-4" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 bg-white p-6 md:p-8 rounded-2xl border border-success/30 shadow-sm" data-id="element-67">
          <div className="flex-shrink-0" data-id="element-68">
            <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-success" data-id="element-69" />
          </div>
          <div className="text-center md:text-left" data-id="element-70">
            <h3 className="text-lg md:text-xl font-bold text-text-primary mb-1.5 md:mb-2" data-id="element-71">
              Garantía de Paz Mental de 7 Días
            </h3>
            <p className="text-text-secondary text-sm leading-relaxed" data-id="element-72">
              Descarga la guía, lee las estrategias y ponlas a prueba. Si en 7
              días sientes que no te ha dado claridad o que no es lo que
              esperabas, envíanos un simple correo y te devolveremos tus $6.36
              inmediatamente. Cero riesgos para ti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}